import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Dimmer.css";
import LinearSlider from "./Sliders/LinearSlider";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";


const Dimmer = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
    equipmentButtons,
    devices,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);
  const [icon, setIcon] = useState(null);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleChangeSlider = (value, button) => {
    setSelectedButton({
      id: button.id,
      sliderValue: value,
    });
  };

  const handleChangeStateButton = (e, button) => {
    setSelectedButton({
      id: button.id,
      sliderValue:
        selectedButton &&
        selectedButton.id == button.id &&
        selectedButton.sliderValue > 0
          ? 0
          : 100,
    });
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    let selectedChannel = ["0", "0", "0", "0", "0", "0", "0", "0"];
    selectedChannel[selectedChannel.length - (button.digit + 1)] = "1";
    let data1 = parseInt(selectedChannel.join(""), 2);
    let data2 =
      button.digit == 0 ? Math.floor(selectedButton.sliderValue) - 1 : 0;
    let data3 =
      button.digit == 1 ? Math.floor(selectedButton.sliderValue) - 1 : 0;
    let data4 =
      button.digit == 2 ? Math.floor(selectedButton.sliderValue) - 1 : 0;
    let data5 =
      button.digit == 3 ? Math.floor(selectedButton.sliderValue) - 1 : 0;
    let data6 =
      button.digit == 4 ? Math.floor(selectedButton.sliderValue) - 1 : 0;
    let data7 =
      button.digit == 5 ? Math.floor(selectedButton.sliderValue) - 1 : 0;
    let data8 = 101;
    let data9 = 101;
    let data10 = 100;
    let data11 = 100;
    if (scenarioCommandDetail.id) {
      // setIsLoading(true);
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: data1,
                data2: data2,
                data3: data3,
                data4: data4,
                data5: data5,
                data6: data6,
                data7: data7,
                data8: data8,
                data9: data9,
                data10: data10,
                data11: data11,
                command_name: String(button.name),
                icon: button.icon ?? icon,
              }
            : command
        )
      );
      setSelectedButton(null);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // UpdateScenarioCommand({
      //   scenario_command_id: scenarioCommandDetail.id,
      //   device_id: button.device_id,
      //   time: scenarioCommandDetail.time,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   data5: data5,
      //   data6: data6,
      //   data7: data7,
      //   data8: data8,
      //   data9: data9,
      //   data10: data10,
      //   data11: data11,
      //   command_name: button.name,
      //   icon: button.icon ?? icon,
      // }).then(({ data: sData }) => {
      //   SuccessToast("دستور با موفقیت جایگزین شد");
      //   const newScenarioCommands = scenarioCommands.map((scn) => {
      //     if (scn.id === scenarioCommandDetail.id) {
      //       return {
      //         ...scn,
      //         device_id: button.device_id,
      //         time: scenarioCommandDetail.time,
      //         data1: data1,
      //         data2: data2,
      //         data3: data3,
      //         data4: data4,
      //         data5: data5,
      //         data6: data6,
      //         data7: data7,
      //         data8: data8,
      //         data9: data9,
      //         data10: data10,
      //         data11: data11,
      //         command_name: button.name,
      //         icon: button.icon ?? icon,
      //       };
      //     }
      //     return scn;
      //   });
      //   setScenarioCommands(newScenarioCommands);
      //   setSelectedButton(null);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    } else {
      // setIsLoading(true);
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: data1,
          data2: data2,
          data3: data3,
          data4: data4,
          data5: data5,
          data6: data6,
          data7: data7,
          data8: data8,
          data9: data9,
          data10: data10,
          data11: data11,
          command_name: String(button.name),
          icon: button.icon ?? icon,
          device_id: button.device_id,
          time: 500,
        },
      ]);
      setSelectedButton(null);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
      // CreateScenarioCommand({
      //   scenario_id: addScenarioCommandDetail.scenario_id,
      //   data1: data1,
      //   data2: data2,
      //   data3: data3,
      //   data4: data4,
      //   data5: data5,
      //   data6: data6,
      //   data7: data7,
      //   data8: data8,
      //   data9: data9,
      //   data10: data10,
      //   data11: data11,
      //   command_name: button.name,
      //   icon: button.icon ?? icon,
      //   device_id: button.device_id,
      //   time: 500,
      // }).then(({ data }) => {
      //   SuccessToast("دستور با موفقیت اضافه گردید");
      //   setScenarioCommands([...scenarioCommands, data.scenario_command]);
      //   setSelectedButton(null);
      //   closeSelectEquipmentRef.current.click();
      //   closeSelectOutputEquipmentRef.current.click();
      //   setIsLoading(false);
      // });
    }
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      return (
        <div>
          <div
            className="dimmer mb-3 p-2"
            style={{
              boxShadow:
                selectedButton && selectedButton.id == button.id
                  ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                  : "0 0.25rem 1rem rgba(147, 158, 170, 0.45)",
            }}
          >
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-9 align-middle" style={{padding: '0 1.7rem'}}>
                    <LinearSlider
                      value={
                        selectedButton && selectedButton.id == button.id
                          ? selectedButton.sliderValue
                          : 0
                      }
                      setValue={(value) => {
                        handleChangeSlider(value, button);
                      }}
                    />
                  </div>
                  <div className="col-3 text-center px-sm-3 my-auto">
                    <div className="text-center">
                      <p className="text-center p-0 m-0 d-block">
                        {button.name}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between pe-3">
                  <div>
                    <div className="form-check form-switch mb-2 p-0">
                      <label className="switch switch-success-app">
                        <input
                          type="checkbox"
                          className="switch-input"
                          onChange={(e) => handleChangeStateButton(e, button)}
                          checked={
                            selectedButton &&
                            selectedButton.id == button.id &&
                            selectedButton.sliderValue > 0
                              ? "checked"
                              : ""
                          }
                        />
                        <span
                          className="switch-toggle-slider"
                          style={{ transform: "rotate(180deg)" }}
                        >
                          <span className="switch-off"></span>
                          <span className="switch-on"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: "11px" }}>
                      {"C" + (button.digit + 1)} - S/
                      {device.serial}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: '0' }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "0.3rem" }}> */}
          {renderButtons()}
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Dimmer);
